<template>
  <CategoryTop :title="title" :breadcrumbs-parent-routes="['preislisten', 'preislistenList']"
    :description="$t('priceList.pkw.description')" />
</template>

<script setup>
import CategoryTop from "../../General/CategoryTop/index.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
const store = useStore();
const route = useRoute();
const { t } = useI18n()

const files = computed(() => store.getters.getSinglePriceList);
const title = computed(() => {
  if (files.value && route.name == "pkw") {
    return t(`priceList.${route.params.slug}.title`);
  }
  return "";
});
</script>
